<template>
  <div>
    <el-drawer v-model="model" :size="anchoSidebar" :with-header="false" @open="refetchData">
     
      <b-container fluid class="px-0">
        <b-card body-class="py-2 d-flex flex-column" variant="primary">
          <h1 class="text-white text-center mb-2">Vídeos de Apoyo</h1>
          <b-form-group>
            <b-input-group>
              <b-form-input type="search" @input="updateQ" placeholder="¿Que quieres ver?" style="text-align: center;"
                class="text-primary" />
              <b-button @click="refetchData()" title="Recargar" v-loading="loading">
                <font-awesome-icon icon="fas fa-rotate-right" />
              </b-button>
            </b-input-group>

          </b-form-group>

          <b-button class="close-btn" @click="() => model = false" variant="secondary" sise="sm">
            <font-awesome-icon icon="fas fa-times" size="2x"/>
          </b-button>
        </b-card>

        <b-row v-loading="loading">
          <b-col cols="12" sm="6" md="6" lg="4" v-for="(video,i) in items" :key="i"
            class=" px-1 d-flex justify-content-center">
            <b-card :style="{backgroundImage: `url(${video.miniatura})`}" class="card-video" no-body
              @click="verVideo(video)">
              <h1 class="text-white text-center my-0 lh-0">{{ video.titulo }}</h1>
            </b-card>

          </b-col>

          <b-col cols="12" v-if="!items.length">
            <section class="text-center">
              <em>No hay Vídeos que mostrar...</em>
            </section>
          </b-col>
        </b-row>
      </b-container>
    </el-drawer>

    <show-video v-model="mostrarVideo" direction="ltr" />
  </div>
</template>

<script setup>


import useVideoStore from '@/store/video';

import useUtils from '@composables/useUtils.js'
import ShowVideo from 'components/ShowVideo.vue';
import useUsuarioStore from '@/store/usuario';

const usuario_store = useUsuarioStore();
const video_store = useVideoStore();

const {rol_name} = storeToRefs(usuario_store);
const mostrarVideo = ref(false);

const {
  loading,
  anchoSidebar
} = useUtils();

const props = defineProps({
  actions:{
    type:[Object,Function],
    default:() => ({})
  }
});

const model = defineModel({
  type:Boolean,
  default:false
});

const {actions} = toRefs(props);

const {
  refetchData,
  fetchData,
  dataMeta,
  items,
  total,
  isSortDirDesc,
  sortBy,
  searchQuery,
  perPage,
  currentPage,
} = actions.value(rol_name);

const verVideo = (vid) => {
  video_store.setVideo(vid);
  mostrarVideo.value = true;
}

const updateQ = _debounce(({ target }) => {
  searchQuery.value = target.value
}, 600)

</script>

<style lang="scss" scoped>

:deep(.card-video){
  text-align:center;
  color:white;
  padding:10px;
  height:150px;
  width:100%;
  // min-width:300px;
  background-repeat: no-repeat;
  background-size: cover;
  overflow-y: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content:center;
  h1{
    opacity: .90;
  }

  &:hover{
    box-shadow: 0px 5px 10px 10px rgba(0, 0, 0, .3);
    
    h1{
      opacity: 1;  
    }
  }
}

.close-btn{
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
  height:40px;
  width:40px;
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg{
    font-size:24pt ;
  }

}

</style>
